/**
 * Created by ren_zhangjing on 2017/7/5.
 */
const host = '',
  project = '',
  prefix = host + project +'/api/';
// oldpwd,newpwd,renewpwd
let apis = {
 
  //2021
  Login: prefix + 'User/Login', //登录
  ResetPwd: prefix + 'User/ResetPwd', //重置密码
  Logout: prefix + 'User/Logout', //退出
  TeachList: prefix + 'SignUp/TeachList ', //获取平台

  UserDetails: prefix + 'User/Details', // 个人信息
  UserUpdate: prefix + 'User/Update', //提交个人信息
  ChangePassword: prefix + 'User/ChangePassword', //修改密码
  LoginOut: prefix + 'Index/LoginOut', //

  
  Study: prefix + 'SignUp/SelectTeach', // 继续教育报名学习
  GetYears: prefix + 'SignUp/GetYears', // 继续教育学习

  GoPay: prefix + 'SignUp/GoPay', //去支付 参数 {teachid,year}
  InvoiceList: prefix + 'Invoice/List', //发票列表
  PostInvoice: prefix + 'Invoice/PostInvoice', //提交发票
  
  Jump: prefix + 'Index/Jump', //登录跳转
  SelectYear: prefix + 'SignUp/SelectYear', //登录跳转
  ToLearn: prefix + 'User/ToLearn', //去学习切换

  GetOpenID: prefix + 'SignUp/GetOpenID', // 获取openid
  WXPay: prefix + 'SignUp/WXPay', // 获取openid
  SignUpPostInvoice: prefix + 'SignUp/PostInvoice', // 收据
  Register: prefix + 'User/Register', //注册
  CheckReg: prefix + 'User/CheckReg', //检查注册身份证号 post
  ToLearnList: prefix + 'User/ToLearnList', //学习年度
  CreditPrint: prefix + 'Credit/Print', //打印 课程列表
  QRCode: prefix + 'Credit/QRCode', //打印 课程列表
  GXKQRCode: prefix + 'Credit/GXKQRCode', //公需课二维码
  CreditCheck: prefix + 'Credit/Check', //手机端检查
  CreditGXKCheck: prefix + 'Credit/GXKCheck', //手机端检查
  List: prefix + 'Credit/List', //学分列表
  Details: prefix + 'Credit/Details', //查看课程
  //公需课
  GXKList: prefix + 'Credit/GXKList', //学分列表
  GXKDetails: prefix + 'Credit/GXKDetails', //公需课详情
  GXKPrint: prefix + 'Credit/GXKPrint', //公需课打印
  GXKQuery: prefix + 'Credit/GXKQuery', //公需课外面查询 ?name=&cardid=
  GetPayUrl: prefix + 'SignUp/GoPay', //支付
  GetPayCode: prefix + 'SignUp/GetPayCode', //支付二维码
  OrderQuery: prefix + 'SignUp/OrderQuery', //支付
  History: prefix + 'Invoice/History', //支付
  History: prefix + 'Invoice/History', //支付
  Query: prefix + 'Credit/Query', // 学分查询
  CheckName: prefix + 'SignUp/CheckName', // 签名
  GetYeePayUrl: prefix + 'SignUp/GetYeePayUrl', // 易宝支付

  Upload: prefix + 'User/Upload', //上传照片
  Details2: prefix + 'User/Details',//个人信息员海南
  Pictures: prefix + 'User/Pictures', //onlintest

  

  
  
 
  
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/index.js